import React from 'react';
import { Button } from 'Components/frameworks/button/Button';
import { ModalWithImageIcon } from 'Components/frameworks/modal-with-image-icon/ModalWithImageIcon';
import { ICONS } from 'Components/utils/icon/icons';
import { ID_MODAL_HEADER__BE__OPTION } from 'Components/utils/identifiers/constants';
import { t } from 'Src/i18n';
type Props = {
  imageUrl: string;
  icon: string;
  proposalId: string;
  onClose: () => void;
  onClick: () => Promise<any>;
};
export const FtcOptionModal = ({
  imageUrl,
  icon = ICONS.PROMO_CODE,
  proposalId,
  onClose,
  onClick,
}: Props) => {
  const ftcPopinTitle = 'booking.summary.futureTravelCredit.popinTitle';
  const ftcPopinDescription = 'booking.summary.futureTravelCredit.popinDescription';
  const ftcPopinDescription2 = 'booking.summary.futureTravelCredit.popinDescription2';
  return (
    <ModalWithImageIcon onClose={onClose} imageUrl={imageUrl} icon={icon}>
      <div className="m-25 text-center">
        <div id={ID_MODAL_HEADER__BE__OPTION} className="mb-10 font-brand text-28 text-saffron">
          {t(ftcPopinTitle)}
        </div>
        <div className="m-0 p-10 pb-0 text-18 font-bold">
          <span className="block text-red">{t(ftcPopinDescription)}</span>
        </div>
        <div className="m-0 p-10 text-16">{t(ftcPopinDescription2)}</div>
        <Button
          className="my-15 min-w-280 text-16 uppercase"
          data-testid="pauseFtcOptionModalButton"
          onClick={onClick}
          size="medium"
        >
          {t('booking.summary.futureTravelCredit.callToAction')}
        </Button>
        <div className="font-bold">
          {t('common.reference')} : {proposalId}
        </div>
      </div>
    </ModalWithImageIcon>
  );
};
